module.exports = __webpack_public_path__ + "img/Grace Johnson.f4432da9.jpg";